'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { Icon } from '@/components/icon';
import { Text } from '@/components/text';
import { Button } from '@/components/ui/button';
import { capture } from '@/features/tracking';
import { useOnboarding } from './onboarding-context';
const PlayerIframePublic = dynamic(() => import('@/features/video').then(mod => ({
  default: mod.PlayerIframePublic
})), {
  ssr: false
});
const VIDEO_INTRODUCTION_ID = 'df056ce1-95ab-4cb7-81be-f17d8ae71997';
export function StepIntroduction() {
  const $ = _c(16);
  const {
    next,
    isLastStep,
    complete,
    skip
  } = useOnboarding();
  let t0;
  if ($[0] !== complete || $[1] !== isLastStep || $[2] !== next) {
    t0 = async () => {
      capture("discovery:introduction_video_complete", {
        playback_duration: 0
      });
      if (isLastStep) {
        await complete();
      } else {
        next();
      }
    };
    $[0] = complete;
    $[1] = isLastStep;
    $[2] = next;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleVideoEnd = t0;
  let t1;
  if ($[4] !== skip) {
    t1 = () => {
      capture("donation:skip_intro_click", {});
      skip();
    };
    $[4] = skip;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleSkip = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text variant="label-md" className="mb-8 block w-full text-center font-medium uppercase tracking-[0.04em]">Please watch this short introduction</Text>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== handleVideoEnd) {
    t3 = <div className="relative aspect-video w-full max-w-[85%] md:max-w-[75%] lg:max-w-[65%]"><PlayerIframePublic videoId={VIDEO_INTRODUCTION_ID} autoplay={true} muted={false} onEnded={handleVideoEnd} loading="eager" /></div>;
    $[7] = handleVideoEnd;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Text variant="body-sm" className="leading-none">Skip</Text>;
    t5 = <Icon name="arrow" className="size-4 rotate-180" />;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[11] !== handleSkip) {
    t6 = <div className="mt-8 flex w-full max-w-[85%] justify-end md:max-w-[75%] lg:max-w-[65%]"><Button variant="default" onClick={handleSkip} className="flex items-center gap-2 bg-white px-4 py-2 font-bold text-black uppercase hover:bg-white hover:text-black hover:opacity-90">{t4}{t5}</Button></div>;
    $[11] = handleSkip;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <div className="flex flex-1 flex-col items-center justify-center px-4">{t2}{t3}{t6}</div>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}